import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-trace",
  "use": "icon-trace-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-trace\"><defs><style></style></defs><path d=\"M832 576V448h128v128H832zM512 832a320 320 0 1 1 320-320 320 320 0 0 1-320 320zm0-512a192 192 0 1 0 192 192 192 192 0 0 0-192-192zm64 640H448V832h128v128zM64 576V448h128v128H64zM448 64h128v128H448V64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol